import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoadingController } from '@ionic/angular';
import { AlertService } from 'src/app/core/services/alert.service';
import { EncryptService } from 'src/app/core/services/encrypt.service';
import { HomeService } from 'src/app/core/services/home.service';
import { StorageService } from 'src/app/core/services/storage.service';

@Component({
  selector: 'app-emergency-details',
  templateUrl: './emergency-details.component.html',
  styleUrls: ['./emergency-details.component.scss'],
})
export class EmergencyDetailsComponent implements OnInit {
  mandatoryBloodGroup:boolean = false;
  mandatoryEmergencyDetails: boolean = false
  emergencyForm :FormGroup
  bloodGroups = ['A+', 'A-', 'B+', 'B-', 'O+', 'O-', 'AB+', 'AB-'];
  relations: Array<any> = [
    { key: 'SON', value: 'Son' },
    { key: 'DAUGHTER', value: 'Daughter'},
    { key: 'SPOUSE', value: 'Spouse'},
    { key: 'MOTHER', value: 'Mother'},
    { key: 'FATHER', value: 'Father'},
    { key: 'MOTHER_IN_LAW', value: 'Mother In Law'},
    { key: 'FATHER_IN_LAW', value: 'Father In Law'},
    { key: 'OTHERS', value: 'Other'}
  ];
  constructor(private _dialogRef: MatDialogRef<EmergencyDetailsComponent>,
      @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
      private fb:FormBuilder,
      private _snackBar: MatSnackBar,
      private homeService:HomeService,
      public loadingController: LoadingController,
      private alertService: AlertService,
      private storageService: StorageService, private encrypt: EncryptService,) { 
      
      }
      
  ngOnInit() {
    
    this.emergencyForm = this.fb.group({
      name: [null],
      bloodGroup:[null, ],
      contactNumber:[null],
      relationWithMember:[null],
    })
    this.checkValidity()
  }

  async checkValidity(){
    this.mandatoryEmergencyDetails = await this.storageService.get('mandatoryEmergencyDetails');
    this.mandatoryBloodGroup = await this.storageService.get('mandatoryBloodGroup');
    if(this.mandatoryBloodGroup && this.mandatoryBloodGroup == true){
      this.emergencyForm.controls['bloodGroup'].setValidators([Validators.required]);
      this.emergencyForm.controls['bloodGroup'].updateValueAndValidity();      
    }
    if(this.mandatoryEmergencyDetails && this.mandatoryEmergencyDetails == true){
      this.emergencyForm.controls['name'].setValidators([Validators.required, Validators.pattern(/^[A-Za-z]+(?:\s[A-Za-z]+)*$/)]);
      this.emergencyForm.controls['name'].updateValueAndValidity();
      this.emergencyForm.controls['contactNumber'].setValidators([Validators.required,Validators.pattern(/^[6789]\d{9}$/)]);
      this.emergencyForm.controls['contactNumber'].updateValueAndValidity();
      this.emergencyForm.controls['relationWithMember'].setValidators(Validators.required);
      this.emergencyForm.controls['relationWithMember'].updateValueAndValidity();
    }
    
  }

  close() {
    this._dialogRef.close();
  }
  async save(){
    const loading = await this.loadingController.create({ message: 'Please wait...' });
    await loading.present(); 
    this.homeService.saveEmergencyDetails(this.emergencyForm.value).subscribe((res:any)=>{
      if(res.status){
        // takeEmergencyDetails
        loading.dismiss();
        this.alertService.presentAlert('Success', '', res.message, 'success');
        this.storageService.set("takeEmergencyDetails", false);
        this._dialogRef.close(true);
      }
    })
    
  }
}
